var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-t-xs-20 p-b-xs-20" },
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              { staticClass: "m-b-xs-20" },
              [
                _c(
                  "ak-button",
                  { attrs: { size: "small" }, on: { click: _vm.backToGrid } },
                  [
                    _c("i", { staticClass: "ak-icon ak-button__icon" }, [
                      _vm._v("arrow_left"),
                    ]),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Ga terug")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.user
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-lg-6" }, [
                _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__header ak-panel__header--info ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Persoonsgegevens")) +
                              " "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.user.email))]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c(
                          "table",
                          { staticClass: "ak-table ak-panel__table" },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Veld"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Waarde"))),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("E-mailadres")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.email) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("Voornaam")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.firstName) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("Achternaam")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.surname) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("Adres")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.fullAddress) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Tweede adres")) + ":"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.fullAddressSecond) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Telefoonnummer")) + ":"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.phone) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("GMS-nummer")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.mobile) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("KUL ID")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.kulId) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("KUL UID")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.kulUid) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Mobile app token")) + ":"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.firebaseToken) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("i", { staticClass: "muted" }, [
                                    _vm._v(_vm._s(_vm.$t("Opmerkingen")) + ":"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "ak-table-column" }, [
                                  _c("a", { attrs: { target: "_blank" } }, [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.user.remarks) +
                                        "\n                                    "
                                    ),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__header ak-panel__header--info ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Bestelbonnen")) +
                              " "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.user.email))]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c(
                          "table",
                          { staticClass: "ak-table ak-panel__table" },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Nummer"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Leverancier"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Datum"))),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.orderRequests
                              ? _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.orderRequests,
                                    function (orderRequest) {
                                      return _c(
                                        "tr",
                                        { staticClass: "ak-table-row" },
                                        [
                                          _c(
                                            "td",
                                            { staticClass: "ak-table-column" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      ":/download/order-request-pdf/" +
                                                      orderRequest.hashId,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        orderRequest.code
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "ak-table-column" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    orderRequest.supplierName
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "ak-table-column" },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(
                                                    orderRequest.dateForDisplay
                                                  ) +
                                                  "\n                                "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-lg-6" }, [
                _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__header ak-panel__header--info ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Bestellingen")) +
                              " "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.user.email))]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c(
                          "table",
                          { staticClass: "ak-table ak-panel__table" },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Bestelnummer"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Datum"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Bedrag"))),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.orders
                              ? _c(
                                  "tbody",
                                  _vm._l(_vm.orders, function (order) {
                                    return _c(
                                      "tr",
                                      { staticClass: "ak-table-row" },
                                      [
                                        order.cart
                                          ? [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "ak-table-column",
                                                },
                                                [
                                                  _c(
                                                    "router-link",
                                                    {
                                                      attrs: {
                                                        to: {
                                                          name: "order-overview",
                                                          params: {
                                                            orderCode:
                                                              order.cart.code,
                                                          },
                                                        },
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            order.cart.code
                                                          ) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "ak-table-column",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm._f("datetime")(
                                                          order.date
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "ak-table-column",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        order.cart
                                                          .totalPriceAfterTaxesForDisplay
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ak-panel ak-panel--no-padding m-b-xs-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ak-panel__header ak-panel__header--info ak-panel__header--small",
                      },
                      [
                        _c("div", { staticClass: "ak-panel__title" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("Stookolie bestellingen")) +
                              " "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.user.email))]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.loading
                      ? _c(
                          "table",
                          { staticClass: "ak-table ak-panel__table" },
                          [
                            _c("thead", [
                              _c("tr", { staticClass: "ak-table-row" }, [
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Bestelnummer"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Datum"))),
                                ]),
                                _vm._v(" "),
                                _c("th", { staticClass: "ak-table-column" }, [
                                  _vm._v(_vm._s(_vm.$t("Bedrag"))),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.fuelOrders
                              ? _c(
                                  "tbody",
                                  _vm._l(_vm.fuelOrders, function (fuelOrder) {
                                    return _c(
                                      "tr",
                                      { staticClass: "ak-table-row" },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "ak-table-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  fuelOrder.orderRequest.code
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "ak-table-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("datetime")(
                                                    fuelOrder.dateAdded
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "ak-table-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  fuelOrder.orderRequest
                                                    .priceTotalForDisplay
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("ak-checkbox", {
              attrs: {
                id: _vm.confirm,
                title: _vm.$t(
                  "Ik bevestig dat alle persoonsgegevens van @email gewist worden",
                  { "@email": _vm.user.email }
                ),
              },
              model: {
                value: _vm.confirm,
                callback: function ($$v) {
                  _vm.confirm = $$v
                },
                expression: "confirm",
              },
            }),
            _vm._v(" "),
            _c(
              "ak-button",
              {
                attrs: { colorMode: "secondary" },
                on: { click: _vm.submitForm },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("Persoonsgegevens wissen")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("router-view", { attrs: { name: "childview" } }),
      _vm._v(" "),
      _c("ak-loader", { attrs: { size: "large", loading: _vm.loading } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }